import React from 'react';
// import { Order } from '../../types';
import { getDateUrgency, getDateColorClass, getBgColor } from '../../utils/dateUtils';
import { BsCalendar, BsClock, BsExclamationTriangle, BsLightningCharge, BsStar } from 'react-icons/bs';
import { OutboundOrder } from '../../../../api/warehouse/generated/src';

interface OrderCardProps {
  order: OutboundOrder;
  onClick: (order: OutboundOrder) => void;
}

export const OrderCard: React.FC<OrderCardProps> = ({ order, onClick }) => {
  const getEarliestDeliveryDate = (order: OutboundOrder) => {
    if (!order.subOrders || order.subOrders.length === 0) {
      return order.deliveryDate;
    }
    const dates = order.subOrders.map(so => new Date(so.deliveryDate));
    // return new Date(Math.min(...dates.map(d => d.getTime()))).toISOString().split('T')[0];
    return new Date(Math.min(...dates.map(d => d.getTime())));
  };
  
  const earliestDeliveryDate = getEarliestDeliveryDate(order);
  const orderNumbers = order.subOrders && order.subOrders.length > 0 
    ? order.subOrders.map(so => so.orderNumber).join(', ')
    : order.orderNumber;
  
  const dateUrgency = getDateUrgency(earliestDeliveryDate);
  const dateColorClass = getDateColorClass(dateUrgency);
  
  const totalShipped = order.items.reduce((sum, item) => sum + item.shippedQty, 0);
  const totalRequired = order.items.reduce((sum, item) => sum + item.requiredQty, 0);
  const totalRemaining = totalRequired - totalShipped;
  
  const borderColor = getBgColor(order, dateUrgency);
  
  const getStatusBadge = () => {
    if (order.status === 'in-progress') {
      return { bg: 'bg-yellow-100', text: 'text-yellow-800', label: 'In Bearbeitung' };
    }
    return { bg: 'bg-blue-100', text: 'text-blue-800', label: 'Offen' };
  };
  
  const statusBadge = getStatusBadge();
  
  const getPriorityIcon = () => {
    if (order.isManualPriority) return <BsStar size={20} className="text-white" />;
    if (order.hasPartialDelivery) return <BsExclamationTriangle size={20} className="text-white" />;
    if (dateUrgency === 'overdue') return <BsClock size={20} className="text-white" />;
    if (dateUrgency === 'urgent') return <BsLightningCharge size={20} className="text-white" />;
    return null;
  };
  
  const priorityIcon = getPriorityIcon();
  
  return (
    <div
      onClick={() => onClick(order)}
      className="bg-white rounded-lg shadow cursor-pointer hover:shadow-lg transition relative overflow-hidden"
    >
      <div className={`absolute left-0 top-0 bottom-0 w-12 ${borderColor} flex items-center justify-center`}>
        {priorityIcon}
      </div>
      <div className="flex justify-between items-start pl-16 pr-4 py-4">
        <div className="flex-1">
          <div className="flex items-start gap-2">
            <div className="flex-1">
              <div className="flex justify-between">
                <h3 className="font-bold text-base md:text-lg text-gray-800">{order.orderNumber}</h3>
                <div className="flex flex-col items-end gap-1">
                  <span className={`px-3 py-1 rounded-full text-sm font-semibold ${statusBadge.bg} ${statusBadge.text}`}>
                    {statusBadge.label}
                  </span>
                </div>
              </div>
              {order.subOrders && order.subOrders.length > 0 && (
                <p className="text-xs md:text-sm text-gray-600 font-mono">{orderNumbers}</p>
              )}
              <p className="text-gray-700 font-semibold mt-1 text-sm md:text-base">{order.customer}</p>
            </div>
          </div>
          <div className="flex items-center gap-4 mt-2 flex-wrap">
            <p className="text-xs md:text-sm text-gray-500">{order.items.length} Positionen</p>
            {order.hasPartialDelivery && (
              <p className="text-xs md:text-sm text-amber-700 font-semibold">
                Noch {totalRemaining} / {totalRequired} Stück offen
              </p>
            )}
            <p className={`text-xs md:text-sm flex items-center gap-1 ${dateColorClass}`}>
              <BsCalendar size={14} className={dateUrgency === 'overdue' ? 'text-red-600' : ''} />
              Lieferung: {new Date(earliestDeliveryDate).toLocaleDateString('de-DE')}
              {dateUrgency === 'overdue' && ' (ÜBERFÄLLIG)'}
            </p>
          </div>
        </div>
        
      </div>
    </div>
  );
};